import axios from 'axios'

// Use environment variable for API base URL, fallback to localhost for development
const apiBaseURL = process.env.REACT_APP_API_BASE_URL || 'https://xmas.westgate.co.ke'

const api = axios.create({
  baseURL: apiBaseURL
})

// Add request interceptor to include auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Add response interceptor to handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token')
      // Use window.location to ensure complete reload
      window.location.href = '/'
    }
    return Promise.reject(error)
  }
)

export default api
